
export default {
  name: 'PageContactIndex',

  head() {
    return {
      title: 'Contact us',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Contact the Paw Paddock team'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Contact Us',
        image: require('~/assets/images/backgrounds/contact-hero.jpg'),
        alt: 'Dog in Paw Paddock'
      }
    }
  }
}
